import Logger from "../Logger";

export default class ContentCardRepository {
    #braze;
    #logger;
    areContentCardsRefreshed = false;

    constructor(braze, logger) {
        this.#braze = braze;
        this.#logger = new Logger(logger, ["Braze", "ContentCardRepository"]);
    }

    getCards = () => {
        return this.#braze.getCachedContentCards().cards ?? [];
    };

    refreshCards = () => {
        this.#logger.info("refresh cards");
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                this.#logger.info("refresh cards TIMED OUT.");
                reject();
            }, 3000);

            this.#braze.requestContentCardsRefresh(
                () => {
                    clearTimeout(timeoutId);
                    this.#logger.info("refresh cards SUCCEED.");
                    resolve();
                },
                () => {
                    clearTimeout(timeoutId);
                    this.#logger.warn("refresh cards FAILED.");
                    reject();
                },
            );
        }).finally(() => {
            this.areContentCardsRefreshed = true;
        });
    };
}
